import script from "./TermsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsModal.vue?vue&type=script&setup=true&lang=ts"

import "./TermsModal.vue?vue&type=style&index=0&id=3060dfd5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3060dfd5"]])

export default __exports__